// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_string = require("rescript/lib/js/js_string.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Nps$ReactHooksTemplate = require("./Nps.res.js");
var Csat$ReactHooksTemplate = require("./csat.res.js");
var DropDown$ReactHooksTemplate = require("./DropDown.res.js");
var LongText$ReactHooksTemplate = require("./LongText.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var StarRating$ReactHooksTemplate = require("./StarRating.res.js");
var RatingGroup$ReactHooksTemplate = require("./RatingGroup.res.js");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");
var MultipleChoice$ReactHooksTemplate = require("./MultipleChoice.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");

function getAnswer(question) {
  var smileyRating = Question$ReactHooksTemplate.questionType(question);
  switch (smileyRating.TAG) {
    case "OpinionScale" :
        return OpinionScale$ReactHooksTemplate.answerToString(smileyRating._0);
    case "StarRating" :
        return StarRating$ReactHooksTemplate.answerToString(smileyRating._0);
    case "LongText" :
        return LongText$ReactHooksTemplate.answerToString(smileyRating._0);
    case "Nps" :
        return Nps$ReactHooksTemplate.answerToString(smileyRating._0);
    case "MultipleChoice" :
        return MultipleChoice$ReactHooksTemplate.answerToString(smileyRating._0);
    case "SmileyRating" :
        return SmileyRating$ReactHooksTemplate.answerToString(smileyRating._0);
    case "Csat" :
        return Csat$ReactHooksTemplate.answerToString(smileyRating._0);
    default:
      return "";
  }
}

function getAnswerList(question) {
  var multipleSelect = Question$ReactHooksTemplate.questionType(question);
  switch (multipleSelect.TAG) {
    case "MultipleSelect" :
        return MultipleSelect$ReactHooksTemplate.answerIdList(multipleSelect._0);
    case "DropDown" :
        return DropDown$ReactHooksTemplate.answerIdList(multipleSelect._0);
    default:
      return /* [] */0;
  }
}

function compare(lhs, branchLogicComparator) {
  switch (branchLogicComparator.TAG) {
    case "EqualsFromValue" :
        return lhs === branchLogicComparator._0;
    case "EqualsFromList" :
        return Belt_List.has(branchLogicComparator._0, lhs, (function (item, search) {
                      return item === search;
                    }));
    case "Conditional" :
        var comparator = branchLogicComparator._0;
        switch (comparator.TAG) {
          case "Equals" :
              var comparatorValueType = comparator._0;
              if (comparatorValueType.TAG === "Int") {
                return Caml_format.int_of_string(lhs) === Caml_format.int_of_string(comparatorValueType._0);
              } else {
                return lhs === comparatorValueType._0;
              }
          case "LessThan" :
              var comparatorValueType$1 = comparator._0;
              if (comparatorValueType$1.TAG === "Int") {
                return Caml_format.int_of_string(lhs) < Caml_format.int_of_string(comparatorValueType$1._0);
              } else {
                return lhs < comparatorValueType$1._0;
              }
          case "GreaterThan" :
              var comparatorValueType$2 = comparator._0;
              if (comparatorValueType$2.TAG === "Int") {
                return Caml_format.int_of_string(lhs) > Caml_format.int_of_string(comparatorValueType$2._0);
              } else {
                return lhs > comparatorValueType$2._0;
              }
          
        }
    case "StringConditional" :
        var stringComparator = branchLogicComparator._0;
        switch (stringComparator.TAG) {
          case "StringEquals" :
              return lhs === stringComparator._0;
          case "StringNotEquals" :
              return lhs !== stringComparator._0;
          case "StringContains" :
              return Js_string.includes(stringComparator._0, lhs);
          case "StringNotContains" :
              return !Js_string.includes(stringComparator._0, lhs);
          
        }
    
  }
}

function isValid(x) {
  if (typeof x !== "object") {
    return true;
  }
  switch (x.TAG) {
    case "BranchLogic" :
        var question = x._0;
        if (Question$ReactHooksTemplate.answered(question)) {
          return compare(getAnswer(question), x._1);
        } else {
          return false;
        }
    case "MultipleAnswerLogic" :
        var question$1 = x._0;
        if (Question$ReactHooksTemplate.answered(question$1)) {
          var lhs = getAnswerList(question$1);
          var listLogicComparator = x._1;
          if (listLogicComparator.TAG === "Contains") {
            return Belt_List.has(lhs, listLogicComparator._0, (function (item, search) {
                          return item === search;
                        }));
          } else {
            return !Belt_List.has(lhs, listLogicComparator._0, (function (item, search) {
                          return item === search;
                        }));
          }
        } else {
          return false;
        }
    case "RatingGroupLogic" :
        var question$2 = x._0;
        if (!Question$ReactHooksTemplate.answered(question$2)) {
          return false;
        }
        var itemId = x._1;
        var ratingGroup = Question$ReactHooksTemplate.questionType(question$2);
        if (ratingGroup.TAG !== "RatingGroup") {
          return false;
        }
        var answers = RatingGroup$ReactHooksTemplate.answer(ratingGroup._0);
        if (answers === undefined) {
          return false;
        }
        var answer = List.find_opt((function (param) {
                return param[0] === itemId;
              }), answers);
        if (answer !== undefined) {
          return compare(String(answer[1]), x._2);
        } else {
          return false;
        }
    
  }
}

exports.isValid = isValid;
/* Nps-ReactHooksTemplate Not a pure module */
